var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1091 561L1091 589",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1091.5,
    cy: 556.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1088.1 565C1087.64 565 1087.24 564.834 1086.9 564.501C1086.57 564.168 1086.4 563.767 1086.4 563.3C1086.4 562.833 1086.57 562.432 1086.9 562.099C1087.24 561.766 1087.64 561.6 1088.1 561.6C1088.57 561.6 1088.97 561.766 1089.31 562.099C1089.64 562.432 1089.81 562.833 1089.81 563.3C1089.81 563.767 1089.64 564.168 1089.31 564.501C1088.97 564.834 1088.57 565 1088.1 565ZM1096.61 565C1096.14 565 1095.74 564.834 1095.41 564.501C1095.08 564.168 1094.91 563.767 1094.91 563.3C1094.91 562.833 1095.08 562.432 1095.41 562.099C1095.74 561.766 1096.14 561.6 1096.61 561.6C1097.08 561.6 1097.48 561.766 1097.81 562.099C1098.15 562.432 1098.31 562.833 1098.31 563.3C1098.31 563.767 1098.15 564.168 1097.81 564.501C1097.48 564.834 1097.08 565 1096.61 565ZM1087.38 551.4L1089.42 555.65H1095.38L1097.72 551.4H1087.38ZM1086.57 549.7H1099.12C1099.45 549.7 1099.7 549.845 1099.87 550.136C1100.04 550.426 1100.04 550.72 1099.89 551.018L1096.87 556.457C1096.71 556.741 1096.5 556.96 1096.24 557.116C1095.98 557.272 1095.69 557.35 1095.38 557.35H1089.04L1088.1 559.05H1098.31V560.75H1088.1C1087.47 560.75 1086.98 560.47 1086.66 559.911C1086.33 559.351 1086.32 558.795 1086.62 558.243L1087.76 556.16L1084.7 549.7H1083V548H1085.77L1086.57 549.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.702002197a3e85717490dcfa255345b8.svg";
export { ForwardRef as ReactComponent };